const hydrateIframe = (iframe) => {
    const dataSrc = iframe.getAttribute('data-src');

    if (!dataSrc || iframe.getAttribute('src')) {
        return;
    }

    iframe.setAttribute('src', dataSrc);
    iframe.removeAttribute('data-src');
    iframe.classList.remove('lazy-load');
};

export default lazy_load_event_form_iframes = () => {
    const iframes = document.querySelectorAll('iframe.lazy-load[data-src]');

    if (!iframes.length) {
        return;
    }

    if (!('IntersectionObserver' in window)) {
        iframes.forEach(hydrateIframe);
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            hydrateIframe(entry.target);
            observer.unobserve(entry.target);
        });
    }, {
        rootMargin: '200px 0px',
    });

    iframes.forEach((iframe) => {
        observer.observe(iframe);
    });
}